import { wrapExpressionForRender } from 'services/React-Utils';

const Case = ({ children }) => wrapExpressionForRender(children);
export default Case;
